import reducer from './reducers';
import * as siteActions from './actions';

export { siteActions };
export default reducer;
